import React, { useState } from 'react';
import TermDatePicker from '../TermDatePicker/TermDatePicker';
import TimePickerCustom, {
	CustomTimePickerTime,
} from '../../../../BaseModule/Components/TimePickerCustom/TimePickerCustom';
import { Moment } from 'moment';
import apiClient from '../../../../../Services/ApiClient';
import { useEffectAsync } from '../../../../../helpers';
import moment from 'moment';
import FullPageLoading from '../../../../BaseModule/Components/FullPageLoading';
import useProcessing from '../../../../Base/Hook/useProcessing';

interface Props {
	workplaceId: string;
	workplaceMemberId: string;
	workplaceCaseTypeId: string;
	onSelect: (data: CustomTimePickerTime | undefined) => void;
	minDate?: string;
	maxDate?: string;
	preselectedDateTime?: string;
}

const CaseTermPicker: React.FC<Props> = ({
	workplaceCaseTypeId,
	workplaceMemberId,
	workplaceId,
	onSelect,
	minDate,
	maxDate,
	preselectedDateTime,
}) => {
	const [times, setTimes] = useState<CustomTimePickerTime[]>([]);
	const { isLoading, handleProcessing } = useProcessing();

	//Loading available times for selected date
	const loadTimes = async (date?: Moment) => {
		//Register function that is loading
		handleProcessing('times', true);
		const dateInString = moment(date).format('YYYY-MM-DD');
		const result = await apiClient.get(
			`/workplaces/${workplaceId}/calendar/availability?date=${dateInString}&workplaceMemberId=${workplaceMemberId}&workplaceCaseTypeId=${workplaceCaseTypeId}`,
		);
		if (result.status === 200) {
			const tempTimes: CustomTimePickerTime[] = [];
			result?.data?.forEach((item: any) => {
				tempTimes.push({
					date: moment(item?.timeFrom).format('YYYY-MM-DD'),
					from: moment(item?.timeFrom).format('HH:mm'),
					to: moment(item?.timeTo).format('HH:mm'),
					priceId: item?.price?.id,
					price: item?.price?.printFormat,
				});
			});
			setTimes(tempTimes);
		} else {
			setTimes([]);
		}
		//Register function that is not loading anymore
		handleProcessing('times', false);
	};

	const handleOnDateSelect = async (date: Moment) => {
		await loadTimes(date);
		onSelect(undefined);
	};

	const handleOnTimeSelect = (time: CustomTimePickerTime) => {
		onSelect(time);
	};

	useEffectAsync(async () => {
		await loadTimes(moment(preselectedDateTime));
	}, []);

	return (
		<>
			{isLoading && <FullPageLoading />}
			<div className='row'>
				<div className='col-md-6'>
					<TermDatePicker
						onChange={handleOnDateSelect}
						onMonthChange={() => setTimes([])}
						workplaceId={workplaceId}
						workplaceMemberId={workplaceMemberId}
						workplaceCaseTypeId={workplaceCaseTypeId}
						handleProcessing={handleProcessing}
						minDate={minDate}
						maxDate={maxDate}
						preselectedDateTime={preselectedDateTime}
					/>
				</div>
				<div className='col-md-6'>
					<TimePickerCustom
						times={times}
						onChange={handleOnTimeSelect}
						preselectedDateTime={preselectedDateTime}
					/>
				</div>
			</div>
		</>
	);
};

export default CaseTermPicker;
